import { SEARCH_FILTER_PARAMETERS } from './constants';

/**
 * cleanseSearchFilters
 *
 * Normalizes and cleans the raw search filter object before sending it to the API.
 * - Removes any undefined, null, or empty string values.
 * - Preserves only the keys that are allowed/expected.
 * - Ensures the resulting object contains valid, API-ready parameters.
 *
 * @param {Object} filters - Raw filter object built from default params, query params, and user input.
 * @returns {Object} - Cleaned and normalized search filters.
 */
export function cleanseSearchFilters(searchFilters = {}, allowedParamsInput = []) {
  // Add all keys your backend accepts here (or pass them in as the 2nd arg)
  const allowedParams = allowedParamsInput.length ? allowedParamsInput : SEARCH_FILTER_PARAMETERS;

  const out = {};

  for (const key of Object.keys(searchFilters)) {
    if (!allowedParams.includes(key)) continue;

    const val = searchFilters[key];

    // prune "not defined" or empty-ish values
    if (val === undefined) continue;
    if (typeof val === 'string' && val.trim() === '') continue;

    out[key] = val;
  }

  return out;
}
